<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="getLogeado"
      v-model="drawer"
      app
      temporary
    
      >
      
      <div align="center" class="mt-3">
        <v-img src="https://www.support-smipack.com/fotos/techsupport.jpg" contain width="90%" ></v-img>
      </div>

      <v-list dense nav >
        <v-list-item five-line>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list dense nav class="py-0">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title>  {{ getdatosUsuario.nombre }}  {{getdatosUsuario.apellidos}}</v-list-item-title>
            <v-list-item-subtitle 
              v-if="getdatosUsuario.nivel === 'USUARIO'">Usuario</v-list-item-subtitle>
            <v-list-item-subtitle 
              v-if="getdatosUsuario.nivel === 'ADMIN'">Administrador</v-list-item-subtitle>
            <v-list-item-subtitle 
              v-if="getdatosUsuario.nivel === 'SUPERVISOR'">Supervisor</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <template v-for="control in AppControl" >
          <v-list-item
            v-for="(child, i) in control.admin"
            :key="i"
            :to="child.path"
            color= "primary"
            v-if="getdatosUsuario.nivel ==='ADMIN'"
          >
            <v-list-item-content >
              <v-list-item-title >
                {{ child.text }} 
              </v-list-item-title>
            </v-list-item-content>
             <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item
            v-for="(child, i) in control.usuario"
            :key="i"
            :to="child.path"
            color= "primary"
            v-if="getdatosUsuario.nivel ==='USUARIO'"
          >
            <v-list-item-content >
              <v-list-item-title >
                {{ child.text }} 
              </v-list-item-title>
            </v-list-item-content>
             <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item
            v-for="(child, i) in control.supervisor"
            :key="i"
            :to="child.path"
            color= "primary"
            v-if="getdatosUsuario.nivel ==='SUPERVISOR'"
          >
            <v-list-item-content >
              <v-list-item-title >
                {{ child.text }} 
              </v-list-item-title>
            </v-list-item-content>
             <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app dense color="grey lighten-2"  v-ripple v-if="getLogeado">
      <v-btn icon>
        <v-icon @click.stop="drawer = !drawer">view_headline</v-icon>  
      </v-btn>
      <img src="@/assets/logo.png" height="50" >
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mr-4" :to="{name: 'myperfil'}">
        <v-icon left color="primary">person</v-icon>
        Perfil
      </v-btn>
      <v-btn icon @click="salir" color="primary">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Ruteo de vistas -->
    <v-main  v-if="getLogeado == false">
      <v-container fluid class="pa-0">
        <v-card class="elevation-0 transparent" :height="tamanioDisplay" >
          <!-- <v-img src="https://actualidadwatch.com/wp-content/uploads/2015/04/iMac-SS.jpg" :height="tamanioDisplay"> -->
            <v-slide-y-transition mode="out-in">
              <router-view/>
            </v-slide-y-transition>
          <!-- </v-img> -->
        </v-card>
      </v-container>
    </v-main>

    <v-main transparent v-if="getLogeado == true">
      <v-container fluid class="pa-5">
        <v-slide-y-transition mode="out-in">
          <router-view/>
        </v-slide-y-transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import store from '@/store'
import {mapGetters, mapActions} from 'vuex'

  export default {
    props: {
      source: String,
    },
    data: () => ({
      logo:'',
      snackbar: false,
      drawer: null,
      AppControl: [
        {
          admin: [ 
            // { text: 'Inicio'   ,icon: 'home' , path: '/home' ,nivel:{admin:true, user:false} },
            { text: 'Usuarios' , icon:'group', path: '/catusuarios'  ,nivel:{admin:'ADMIN', user:false} },
            { text: 'Series' , icon:'list', path: '/listseries' ,nivel:{admin:'ADMIN', user:true}},
            { text: 'Admin Series' , icon:'dynamic_feed', path: '/tabseries',nivel:{admin:'ADMIN', user:false} },
            { text: 'Categorías' , icon:'bookmark', path: '/categorias',nivel:{admin:'ADMIN', user:false} },

          ],
          supervisor: [ 
            // { text: 'Inicio'   ,icon: 'home' , path: '/home' ,nivel:{admin:true, user:false} },
            { text: 'Series' , icon:'list', path: '/listseries' ,nivel:{admin:'ADMIN', user:true}},
            { text: 'Admin Series' , icon:'dynamic_feed', path: '/tabseries',nivel:{admin:'ADMIN', user:false} },
            { text: 'Categorías' , icon:'bookmark', path: '/categorias',nivel:{admin:'ADMIN', user:false} },

          ],

          usuario: [ 
            { text: 'Series' , icon:'list', path: '/listseries' ,nivel:{admin:'ADMIN', user:true}},
          ],
        }
       
      ],
    }),

    created(){ },

    methods:{
      ...mapActions('Login', ['salirLogin']),

      salir(){
        this.salirLogin()
        // Mando a llamar la accion salir
        this.$store.dispatch("salir")
      },

    },

    computed:{
     ...mapGetters('Login', ['getdatosUsuario', 'getLogeado']),
    
      logueado(){
        return this.$store.state.usuario;
      },

      tamanioDisplay () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return this.$vuetify.breakpoint.height
          break;
          case 'sm': 
            return this.$vuetify.breakpoint.height
          break;
          case 'md':
            return this.$vuetify.breakpoint.height
          break;
          case 'lg':
            return this.$vuetify.breakpoint.height 
          break;
          case 'xl':
            return this.$vuetify.breakpoint.height
          break;
        }
      }
    }
}
</script>


